import Transform from './Base';
import store from '@/store';

export default class PlayersTransform extends Transform {
  /**
   * Method used to transform fetched players.
   *
   * @param player The fetched player.
   *
   * @returns {Object} The transformed player.
   */
  static fetch(player) {
    return {
      id: player._id,
      player_name: player.player_name || '',
      player_number: player.player_number || '',
      team: !!player.team 
        ? {...player.team, ...{id: player.team._id}}
        : {id : -1, team_name: ''},
      external_id: !!player.external_id ? player.external_id : '',
      position: player?.position || '',
    };
  }
  
  static updateItem(oldEl, newEl) {
    const teams = store.getters['teams/items'];
    const { external_id, player_name, player_number, position, team_id } = newEl;
    try {
      return {
        ...oldEl,
        external_id,
        player_name,
        player_number,
        position,
        team: teams.find(({ id }) => id === team_id),
      };
    } catch {
      return oldEl;
    }
  }
}
